module.exports = __webpack_public_path__ + "static/media/ic_manomano.d1f44fec.png";